"use strict"

module.exports = (str) => !!str && str.trim().length >= 8;